export const apiUrl = "https://api.openperpetuum.com";


// WEBPACK FOOTER //
// ./src/config.js